import { useNavigate } from "react-router-dom";

export default function InvalidUrl() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-red-50 text-red-700 p-6">
      <h1 className="text-4xl font-bold mb-4">Invalid URL</h1>
      <p className="mb-6">The page you are looking for does not exist.</p>
      <button
        onClick={() => navigate("/")}
        className="bg-red-700 text-white px-4 py-2 rounded hover:bg-red-800"
      >
        Go to Home
      </button>
    </div>
  );
}
